module.exports = __webpack_public_path__ + "img/success_icon.7a9bbf6b.png";